<div class="container">
	<div class="row">
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Add Organization</div>
				<div class="content">
					<div class="form-group">
						<label>Organization name</label>
						<input [(ngModel)]="addorganization.name" type="text" class="form-control">
					</div>
					<div class="form-group">
						<button (click)="AddOrganization()" class="btn btn-success">Add Organization</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Add User to Organization</div>
				<div class="content">
					<div class="form-group">
						<label>Organization name</label>
						<select [(ngModel)]="adduser.organization" class="form-control">
							<option *ngFor="let org of organizations" [ngValue]="org">{{org.name}}</option>
						</select>
					</div>
					<div *ngIf="!brand.localCloud" class="form-group">
						<label for="email">Email address</label>
						<input [(ngModel)]="adduser.email" name="email" type="email" id="email" class="form-control">
					</div>
					<div *ngIf="brand.localCloud" class="form-group">
						<label for="email">User name</label>
						<input [(ngModel)]="adduser.email" name="email" type="text" id="email" class="form-control">
					</div>
					<div class="form-group">
						<label>Password</label>
						<input [(ngModel)]="adduser.password" type="password" class="form-control">
					</div>
					<div class="form-group">
						<label>Role</label>
						<select [(ngModel)]="adduser.role" class="form-control">
							<option value="orgadmin">Organization Administrator</option>
							<option value="user">User</option>
							<option value="readonly">Read Only</option>
						</select>
					</div>
					<div class="form-group">
						<button (click)="AddUser()" class="btn btn-success">Add User</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-12">
			<div *ngIf="errormessage" class="message-bad">{{errormessage}}</div>
		</div>
	</div>
</div>